var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('div',{staticClass:"ErrorComp a-cover z-100 overflow-hidden flex-c bg-white text-black"},[_c('h1',{staticClass:"text-3xl font-body-bold text-center",domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }